<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">预算编制</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="height:20px"></div>
				<div class="findcontent">
					<div class="findTitle">预算单</div>
					<div class="formlist">
						<el-form :inline="true" :model="formInline" class="demo-form-inline">
							<el-form-item label="预算单编号">
								<el-input v-model="formInline.budget_number" style="width:160px" size="small" readonly>
								</el-input>
							</el-form-item>
							<el-form-item label="年度">
								<el-date-picker v-model="formInline.annual" type="year" value-format="yyyy"
									placeholder="选择年" size="small" style="width:120px" @input="changeInput()">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="项目名称">
								<el-select v-model="formInline.project_id" clearable style="width:160px"
									@input="changeInput()" @change="proClick" size="small" filterable>
									<el-option v-for="item in projectList" :key="item.id" :label="item.project_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="组织架构">
								<el-input v-model="formInline.group_structure" style="width:160px" size="small">
								</el-input>
							</el-form-item>
							<el-form-item label="备注">
								<el-input v-model="formInline.notes" style="width:160px" size="small"
									@input="changeInput()"></el-input>
							</el-form-item>
							<el-form-item label="制表人">
								<el-input v-model="formInline.tabulator" style="width:160px" size="small" readonly>
								</el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>

				<div class="btnicon">
					<div class="btnview" @click="Save()">
						<img src="../../../assets/budget/保存.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">保存</span>
					</div>
					<div class="btnview" @click="findOne()">
						<img src="../../../assets/budget/提交审核.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">提交审核</span>
					</div>
					<div class="btnview">
						<img src="../../../assets/budget/导出.png" style="vertical-align: middle;margin-top: -3px;" />
						<span style="font-size: 17px;">导出</span>
					</div>
				</div>

				<div class="tabs">
					<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" lazy="true">
						<el-tab-pane label="预算汇总表" name="first">
							<div>
								<el-table :data="tableDataOne" ref="multipleTable"
									:header-cell-style="{ background: '#d3eae2', color: '#000000' }" border
									@selection-change="handleSelectionChange" style="width: 100%" height="480">
									<el-table-column align="center" label="序号" width="50">
										<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
									</el-table-column>
									<el-table-column prop="firstName" align="center" label="预算分类"></el-table-column>
									<el-table-column prop="accumulate_1" align="center" label="1月累计">
										<template slot-scope="scope" ref="loginForm2">
											<el-input v-model="scope.row.accumulate_1" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, scope.$index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_1 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_2" align="center" label="2月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_2" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_2 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_3" align="center" label="3月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_3" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_3 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_4" align="center" label="4月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_4" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_4 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_5" align="center" label="5月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_5" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_5 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_6" align="center" label="6月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_6" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_6 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_7" align="center" label="7月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_7" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_7 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_8" align="center" label="8月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_8" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_8 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_9" align="center" label="9月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_9" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_9 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_10" align="center" label="10月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_10" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_10 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_11" align="center" label="11月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_11" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_11 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate_12" align="center" label="12月累计">
										<template slot-scope="scope">
											<el-input v-model="scope.row.accumulate_12" v-if="scope.row.spare5 == 1"
												class="table" size="small"
												@change="updateDataOne($event, index, scope.row)">
											</el-input>
											<span v-else>{{ scope.row.accumulate_12 }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="accumulate" align="center" label="合计"></el-table-column>

								</el-table>
							</div>
						</el-tab-pane>
						<el-tab-pane label="预算表">
							<div>
								<el-table :data="tableDataTwo" ref="myScrollbar"
									:header-cell-style="{ background: '#d3eae2', color: '#000000' }" border
									@selection-change="handleSelectionChange" style="width: 100%"
									@cell-mouse-leave="cellMouseLeave" :key="changeKey" height="480"
									:cell-class-name="tableRowClassName1">
									<!-- <el-table-column align="center" label="" width="50">
										<template slot-scope="scope">
											<img src="../../../assets/budget/新增预算.png" @click="budClick(scope.row)"
												style="vertical-align: middle;margin-top:-2px" />
										</template>
									</el-table-column>
								
								@cell-mouse-enter="cellMouseEnter" :span-method="objectSpanMethod"
								-->
									<el-table-column prop="series" align="center" label="预算分类" width="150" fixed>
										<template slot-scope="scope">
											<span>{{ scope.row.first_name }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="secondary_name" align="center" label="预算名称" width="200" fixed>
									</el-table-column>
									<el-table-column prop="invoice_name" align="center" v-for="(item, index) in dateList"
										:key="index" width="150">
										<template slot="header" slot-scope="scope" ref="loginForm">
											<span>{{ item.monthly }}月月度预算</span>
											<img src="../../../assets/budget/复制.png" @click="dateClick(item.monthly)"
												style="vertical-align: middle;margin-top:-2px" />
										</template>
										<el-table-column align="center" label="在岗人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].employees_number"
													size="small" class="table"
													@change="updateData($event, index, scope.row)">
												</el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="倒休人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].retroactive_rest"
													class="table" size="small"
													@change="updateData($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="合计人数">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].amount_number" class="table"
													size="small" @change="updateData($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="单人金额">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].individual_amount"
													class="table" size="small"
													@change="updateData($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
										<el-table-column prop="series" align="center" label="总金额">
											<template slot-scope="scope">
												<el-input v-model="scope.row.outsideList[index].assemble_amount"
													class="table" size="small"
													@change="updateData($event, index, scope.row)"></el-input>
											</template>
										</el-table-column>
									</el-table-column>
								</el-table>
							</div>
							<el-dialog title="新增预算" v-if="budShow" :visible.sync="budShow" width="30%" center="true"
								:close-on-click-modal="false">
								<div>
									<el-checkbox-group v-model="budLists" @change="handleCheckedbudChange"
										style="margin-bottom: 15px;margin-left: 15%;">
										<el-checkbox v-for="item in budList" :label="item.id" :key="item.id"
											style="margin-bottom: 20px;width: 40%;">
											{{ item.secondary_category }}
										</el-checkbox>
									</el-checkbox-group>
									<div style="text-align: center;">
										<el-button type="goon" @click="AddSavebud()">保存</el-button>
									</div>
								</div>
							</el-dialog>
							<el-dialog title="选择月份" :visible.sync="dateShow" width="30%" center="true"
								:close-on-click-modal="false">
								<div>
									<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange"
										style="margin-bottom: 20px;">
										<el-checkbox v-for="(item, index) in dates" :label="item.id" :key="index"
											style="margin-bottom: 20px;">
											{{ item.date }}
										</el-checkbox>
									</el-checkbox-group>
									<div style="text-align: center;">
										<el-button type="goon" @click="AddSaveDate()">保存</el-button>
									</div>
								</div>
							</el-dialog>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<el-dialog title="审核" :visible.sync="spShow" width="35%" center="true" :close-on-click-modal="false">
			<div style="width: 100%;">
				<div>审核名称：年度预算审核</div>
				<el-table ref="multipleTable" :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
					:data="examineDetailsList" tooltip-effect="dark" style="width: 100%" height="300"
					@selection-change="handleSelectionChange">
					<el-table-column label="序号" width="50">
						<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
					</el-table-column>
					<el-table-column prop="node" label="节点" align="center">
					</el-table-column>
					<el-table-column prop="role_name" label="岗位" align="center">
					</el-table-column>
					<el-table-column prop="staff_name" label="审核人" align="center">
					</el-table-column>
				</el-table>
				<div style="text-align: center;margin-top: 10px;">
					<el-button type="goon" @click="findTwo()">确定</el-button>
				</div>
			</div>
			<div style="height: 30px;"></div>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	data() {
		return {
			scrollTop: 0,

			spShow: false,
			tableList: [],
			examineDetailsList: [],

			changeKey: '',
			total: 0,
			dateShow: false,
			budShow: false,
			activeName: 'first',
			tableDataOne: [],
			tableDataTwo: [],
			ids: [],
			checkedCities: [],
			checkedbuds: [],
			//条件
			formInline: {},
			projectList: [],
			budLists: [],
			dateLists: [],
			dateList: [{
				monthly: 1
			}, {
				monthly: 2
			}, {
				monthly: 3
			}, {
				monthly: 4
			}, {
				monthly: 5
			}, {
				monthly: 6
			}, {
				monthly: 7
			}, {
				monthly: 8
			}, {
				monthly: 9
			}, {
				monthly: 10
			}, {
				monthly: 11
			}, {
				monthly: 12
			},
			],
			budList: [],
			budRow: {},
			testList: [],
			orderIndexArr: [],
			hoverOrderArr: [],
			dateNum: '',
			test: 0,
			dates: [{
				id: 1,
				date: '一月'
			}, {
				id: 2,
				date: '二月'
			}, {
				id: 3,
				date: '三月'
			}, {
				id: 4,
				date: '四月'
			}, {
				id: 5,
				date: '五月'
			}, {
				id: 6,
				date: '六月'
			}, {
				id: 7,
				date: '七月'
			}, {
				id: 8,
				date: '八月'
			}, {
				id: 9,
				date: '九月'
			}, {
				id: 10,
				date: '十月'
			}, {
				id: 11,
				date: '十一月'
			}, {
				id: 12,
				date: '十二月'
			}]
		};

	},
	updated() {
		this.$nextTick(() => {
			this.$refs.multipleTable.doLayout()
		})
	},
	watch: {
		scrollTop() {
			console.log(this.scrollTop);
		},
	},
	methods: {
		async findOne() {
			var data = await this.$globals.AxiosPost('budgetForm/getOaManageApproval', {
				id: this.formInline.id,
				budget_number: this.formInline.budget_number,
				annual: this.formInline.annual,
				project_id: this.formInline.project_id,
				group_structure: this.formInline.group_structure,
				notes: this.formInline.notes,
				tabulator: this.formInline.tabulator,
			});
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				console.log(data);
				if (code === '200') {
					this.tableList = data
					this.examineDetailsList = data.examineDetailsList
					this.spShow = true
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},
		async findTwo() {
			var data = await this.$globals.AxiosPost('budgetForm/Approval', {
				id: this.formInline.id,
				budget_number: this.formInline.budget_number,
				annual: this.formInline.annual,
				project_id: this.formInline.project_id,
				group_structure: this.formInline.group_structure,
				notes: this.formInline.notes,
				tabulator: this.formInline.tabulator,
				approval: this.tableList
			});
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.message;
				console.log(data);
				if (code === '200') {
					this.$message.success(data);
					this.spShow = false
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},
		async Find() {
			var data = await this.$globals.AxiosGet("budgetForm/generateCode");
			this.formInline = data.data;
			this.tableDataOne = data.data.summaryList;
			this.tableDataTwo = data.data.outsideDtoList;
		},
		async changeInput() {
			var record = {
				id: this.formInline.id,
				budget_number: this.formInline.budget_number,
				annual: this.formInline.annual,
				project_id: this.formInline.project_id,
				group_structure: this.formInline.group_structure,
				notes: this.formInline.notes,
				tabulator: this.formInline.tabulator,
			}
			var data = await this.$globals.AxiosPost('budgetForm/updateBudget', record);
			if (data.code === '200') {
				console.log(11111)
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		async proClick(val) {
			var data = await this.$globals.AxiosGet("budgetForm/getName?info=" + val);
			this.formInline.group_structure = data.data;
		},
		async FindOne() {
			var data = await this.$globals.AxiosGet("formSummary/getSummaryList?info=" + this.formInline.id);
			this.tableDataOne = data.data;

		},
		async FindTwo() {
			var data = await this.$globals.AxiosGet('budgetForm/getOutsideList?info=' + this.formInline.id);
			if (data.code === '200') {
				this.tableDataTwo = data.data;
				// this.getOrderNumber()
				this.changeKey = !this.changeKey;
				setTimeout(() => {
					this.$refs.myScrollbar.bodyWrapper.scrollTop = this.scrollTop
				}, 300)
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		tableScroll() {
			this.$refs.myScrollbar.bodyWrapper.addEventListener('scroll', (res) => {
				this.scrollTop = res.target.scrollTop
			})
		},
		handleClick(tab, event) {
			console.log(tab.name);
			if (tab.name == 'first') {
				this.FindOne()
			} else {
				setTimeout(() => {
					this.tableScroll()
				}, 1000)
				this.FindTwo()
			}
		},
		async updateData(event, index, row) {
			console.log(index);
			var record = {
				budget_id: this.formInline.id,
				first_id: row.first_id,
				secondary_id: row.secondary_id,
				monthly: row.outsideList[index].monthly,
				employees_number: row.outsideList[index].employees_number,
				retroactive_rest: row.outsideList[index].retroactive_rest,
				amount_number: row.outsideList[index].amount_number,
				individual_amount: row.outsideList[index].individual_amount,
				assemble_amount: row.outsideList[index].assemble_amount,
			}
			var data = await this.$globals.AxiosPost('formOutside/add', record);
			if (data.code === '200') {
				// if (event) {
				// 	event.target.blur()
				// }
				this.$message.success('修改成功！');
				this.FindTwo()
				setTimeout(() => {
					this.tableScroll()
				}, 1000)
				this.$refs["loginForm"].$el[index + 1].focus();
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		async updateDataOne(event, index, row) {
			console.log(index);
			var record = {
				budget_id: this.formInline.id,
				first_id: row.first_id,
				accumulate_1: row.accumulate_1,
				accumulate_2: row.accumulate_2,
				accumulate_3: row.accumulate_3,
				accumulate_4: row.accumulate_4,
				accumulate_5: row.accumulate_5,
				accumulate_6: row.accumulate_6,
				accumulate_7: row.accumulate_7,
				accumulate_8: row.accumulate_8,
				accumulate_9: row.accumulate_9,
				accumulate_10: row.accumulate_10,
				accumulate_11: row.accumulate_11,
				accumulate_12: row.accumulate_12,
			}
			var data = await this.$globals.AxiosPost('formSummary/updateSummary', record);
			if (data.code === '200') {
				// if (event) {
				// 	event.target.blur()
				// }
				this.$message.success('修改成功！');
				this.FindOne()
				this.$refs["loginForm2"].$el[index + 1].focus();
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		// 新增预算
		async budClick(e) {
			//
			console.log(this.checkedbuds)
			this.budRow = e;
			var data = await this.$globals.AxiosGet('BudgetSecondary/getList?info=' + e.first_id);
			if (data.code === '200') {
				// this.checkedbuds = [];
				this.budShow = true;
				this.budList = data.data;
				console.log(this.testList)
				let arr = this.testList.find(item => item.first_id == e.first_id)
				this.budLists = arr ? arr.check : []
			} else {
				this.$message.warning('请求失败！请稍后重试');
			}
		},
		handleCheckedbudChange(value) {
			this.budLists = value
		},
		async AddSavebud() {
			var data = await this.$globals.AxiosPost('budgetForm/adjust', {
				ids: this.budLists,
				budget_id: this.budRow.budget_id,
				first_id: this.budRow.first_id,
			});
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				if (data.code === '200') {
					this.$message.success('保存成功！');
					this.budShow = false;
					console.log(this.testList)
					let arr = this.testList.find(item => item.first_id == this.budRow.first_id)
					if (arr) {
						this.testList.forEach(item => {
							item.check = this.budLists
						})
					} else {
						this.testList.push({
							check: this.budLists,
							first_id: this.budRow.first_id
						})
					}
					this.FindTwo();
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			};
		},
		// 选择日期
		dateClick(e) {
			this.checkedCities = [];
			this.dateNum = e;
			this.dateShow = true
		},
		handleCheckedCitiesChange(value) {
			this.dateLists = value
		},
		async AddSaveDate() {
			var content = {
				budget_id: this.formInline.id,
				monthly: this.dateNum,
				ids: this.dateLists
			}
			var data = await this.$globals.AxiosPost('formOutside/cover', content);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success('修改成功！');
					this.dateShow = false;
					this.FindTwo()
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}


		},
		async Save() {
			var data = await this.$globals.AxiosPost('budgetForm/update', this.formInline);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},
		// 全选
		handleSelectionChange(e) {
			this.ids = [];
			e.forEach(item => {
				this.ids.push(item.id);
			});
		},
		//分页
		handleCurrentChange(val) {
			this.condition.page_num = val;
		},
		getOrderNumber() {
			const orderObj = {};
			this.tableDataTwo.forEach((item, index) => {
				item.rowIndex = index;
				if (orderObj[item.first_id]) {
					orderObj[item.first_id].push(index);
				} else {
					orderObj[item.first_id] = [];
					orderObj[item.first_id].push(index);
				}
			});
			// 将数组长度大于1的值 存储到this.orderIndexArr（也就是需要合并的项）
			Object.keys(orderObj).forEach((key) => {
				if (orderObj[key].length > 1) {
					this.orderIndexArr.push(orderObj[key]);
				}
			});

			console.log(this.tableDataTwo)

		},
		objectSpanMethod({
			row,
			column,
			rowIndex,
			columnIndex
		}) {
			if (columnIndex === 0 || columnIndex === 1) {
				// for (let i = 0; i < this.orderIndexArr.length; i += 1) {
				// 	let element = this.orderIndexArr[i];
				// 	for (let j = 0; j < element.length; j += 1) {
				// 		let item = element[j];
				// 		if (rowIndex === item) {
				// 			if (j === 0) {
				// 				return {
				// 					rowspan: element.length,
				// 					colspan: 1,
				// 				};
				// 			}
				// 			if (j !== 0) {
				// 				return {
				// 					rowspan: 0,
				// 					colspan: 0,
				// 				};
				// 			}
				// 		}
				// 	}
				// }
			}
		},
		tableRowClassName1({
			row,
			rowIndex
		}) {
			// let arr = this.hoverOrderArr;
			// for (let i = 0; i < arr.length; i += 1) {
			// 	if (rowIndex === arr[i]) {
			// 		return 'hovered-row';
			// 	}
			// }
		},
		cellMouseEnter(row, column, cell, event) {
			this.rowIndex = row.rowIndex;
			// this.hoverOrderArr = [];
			// this.orderIndexArr.forEach((element) => {
			// 	if (element.indexOf(this.rowIndex) >= 0) {
			// 		this.hoverOrderArr = element;
			// 	}
			// });
		},
		cellMouseLeave(row, column, cell, event) {
			this.rowIndex = '-1';
			this.hoverOrderArr = [];
		},
	},
	async created() {
		// var data = await this.$globals.AxiosGet('budgetForm/generateCode');
		// this.formInline = data.data;
		this.Find();
		this.formInline.tabulator = this.$globals.user.name;
		var projectList = await this.$globals.AxiosPost("tenderHonourAgreement/getProjectList", {});
		this.projectList = projectList.data;
	},
};
</script>

<style scoped>
.findcontent {
	border: 1px solid #006e4b;
	background-color: #fafff9;
	padding: 10px 20px;
	margin: 0 30px;
}

.findTitle {
	font-size: 18px;
	font-weight: 600;
	color: #006e4b;
	margin-top: 10px;
}

.formlist {
	margin-top: 10px
}

.btnicon {
	display: flex;
	margin: 20px 0 10px 10px;
}

.btnview {
	margin-left: 20px;
}

.tabs {
	margin: 0 30px;
}
</style>
<style>
.tabs .el-tabs--border-card>.el-tabs__header {
	background-color: #fafafa;
}

.tabs .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
	border-top: 3px solid #006e4b;
	font-size: 18px;
	border-right-color: #fff;
	border-left-color: #fff;
}

.tabs .el-tabs--border-card>.el-tabs__header {
	border: none;
}

.tabs .el-tabs--border-card {
	border: none
}

.tabs .el-tabs--border-card>.el-tabs__content {
	padding: 5px 0;
}

.tabs .el-tabs__item {
	font-size: 18px;
}

.tabs .el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child {
	font-size: 18px;
}

.tabs .el-tabs__nav {
	height: 40px;
}

.table .el-input--small .el-input__inner {
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// Budgeting.vue?7b3d85d4